export const normalizeCategoryName = (name?: string) => {
    const segments = name.split("_")
    for (let i = 0; i < segments.length; i++) {
        segments[i] = segments[i].substring(0, 1).toUpperCase() + segments[i].substring(1)
    }

    return segments.join(" ")

}